import { gql } from '@apollo/client';

const GET_ORDERS = gql`
  query GetOrders($orderBy: String, $statuses: [String]) {
    me {
      id
      orders(orderBy: $orderBy, statuses: $statuses) {
        edges {
          node {
            id
            orderId
            sumOfModelQuantities
            allModelsReady
            allComponentVariantsReady
            status
            createdDate
            modifiedDate
            correctedOrder {
              id
              orderId
              status
            }
            models {
              edges {
                node {
                  modelSpecificationNode {
                    id
                    itemCode
                  }
                }
              }
            }
            orderSuppliers {
              edges {
                node {
                  id
                  supplier {
                    id
                    code
                    shortName
                    fullName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default GET_ORDERS;
